module.exports = import("https://d3js.org/d3.v7.min.js");;